export default "__VITE_ASSET__c0d75bc1__"